import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VContainer,{attrs:{"fluid":""}},_vm._l((_vm.props.layout.rows),function(row,index){return _c(VRow,{key:index},_vm._l((row),function(col,index){return _c(VCol,{key:index,attrs:{"cols":col.cols}},[_c('div',[_c('span',{staticClass:"data-inline-data-title"},[_vm._v("\n          "+_vm._s(col.label)+"\n        ")]),_c('div',{class:col.class
              ? col.class
              : ['data-inline-data', 'text-justify']},[_c('Field',{attrs:{"field":_vm.current_qunit[col.id],"unit":_vm.current_qunit}})],1)])])}),1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }